module.exports = __webpack_public_path__ + "media/assets/images/sales-processes-delete-dbe10aca499caa586bcfd1cb15f1e41c.svg";